import { performGetRequest } from '@atlassian/jira-fetch';
import {
	type ApplicationEdition,
	type ApplicationKey,
	editionKeyToEdition,
} from '@atlassian/jira-shared-types';
import type { ApplicationEditionResponse } from '@atlassian/jira-up-flow-iframe/src/services/edition-polling/types';

export const fetchSiteEdition = async (product: ApplicationKey): Promise<ApplicationEdition> => {
	const url = '/rest/internal/latest/meta/edition';
	const response: ApplicationEditionResponse = await performGetRequest(url);
	return editionKeyToEdition(response[product]);
};
